<template>
    <div>
        <zm-table :data="list">
            <zm-table-column prop="keyLabel" :label="keyLabel"></zm-table-column>
            <zm-table-column prop="threadName" label="threadName"></zm-table-column>
            <zm-table-column prop="lastWorkingTaskId" label="lastWorkingTaskId">
                <template slot-scope="scope">
                    <a :href="'/#/dashboard/task?id=' + scope.row.lastWorkingTaskId" target="_blank">
                    {{ scope.row.lastWorkingTaskId }}</a>
                </template>
            </zm-table-column>
            <zm-table-column prop="lastWorkingTime" label="lastWorkingTime">
                <template slot-scope="scope">
                    {{ new Date(parseInt(scope.row.lastWorkingTime)).toLocaleString() }}
                </template>
            </zm-table-column>
            <zm-table-column prop="errorMessage" label="errorMessage"></zm-table-column>
        </zm-table>
    </div>
</template>
<script>
export default {
    name: 'threadInfo',
    props: ['keyLabel', 'data'],
    data () {
        return {
            list: []
        }
    },
    created () {
        this.list = Object.keys(this.data).map(item => {
            const val = this.data[item]
            val.keyLabel = item
            return val
        })
    }
}
</script>
